import * as React from 'react';
import { ComponentLayout } from 'src/components/common/modules/component-layout/code-split/component-layout-component';
import { ComponentLayoutType } from 'src/components/common/modules/component-layout/component-layout';
import { V2FeaturedHotelDealsComponent } from './code-split/v2-featured-hotel-deals-component';
import { checkValue } from 'src/components/common/helper';

const V2FeaturedHotelDeals: React.FC<ComponentLayoutType<any>> = (props) => {
  // No hotel ids or destination so no deal module rendered 
  if (!checkValue(props?.data?.hotelIds) && !(checkValue(props?.data?.destination)  || checkValue(props?.data?.destinationId)) && !checkValue(props?.data?.dealList)) {
    return <></>;
  }

  return (
    <ComponentLayout {...props}>
      <V2FeaturedHotelDealsComponent />
    </ComponentLayout>
  );
};

export default V2FeaturedHotelDeals;
